import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UIState, Notification } from '../../../shared/types';

const initialState: UIState = {
  sidebarOpen: false,
  theme: 'light',
  notifications: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state: UIState) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state: UIState, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setTheme: (state: UIState, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
      // Sauvegarder le thème dans localStorage
      localStorage.setItem('theme', action.payload);
    },
    addNotification: (state: UIState, action: PayloadAction<Omit<Notification, 'id' | 'created_at'>>) => {
      state.notifications.push({
        id: Date.now(),
        created_at: new Date().toISOString(),
        ...action.payload,
      });
    },
    removeNotification: (state: UIState, action: PayloadAction<number>) => {
      state.notifications = state.notifications.filter(
        (notification: Notification) => notification.id !== action.payload
      );
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setTheme,
  addNotification,
  removeNotification,
} = uiSlice.actions;

export default uiSlice.reducer;

